import { Component, Input } from '@angular/core';
import { RentalReservationModel } from '@/models/rentals/rental-reservation.model';

@Component({
  selector: 'app-reservation-conflict-banner',
  templateUrl: './reservation-conflict-banner.component.html',
  styleUrls: ['./reservation-conflict-banner.component.scss'],
})
export class ReservationConflictBannerComponent {
  @Input() conflicts: RentalReservationModel[] = [];
  @Input() upcoming: RentalReservationModel[] = [];

  get hasContent(): boolean {
    return this.conflicts.length > 0 || this.upcoming.length > 0;
  }

  customerLabel(reservation: RentalReservationModel): string {
    return reservation.denominazioneCliente || 'Cliente N/D';
  }
}
